module.exports = __webpack_public_path__ + "img/Bodice-Back-Sleeve1-Kb-Lc.b5b91269.png";